
/**
 * @file commons.constants.js
 * @module QuotesConstants
 * @description Common constants used across the quotes module.
 */

/**
 * Transfer options available for quotes.
 * @type {Array<{value: string, label: string}>}
 */
export const TRANSFER_OPTIONS = [
    { value: "ARRIVAL", label: "Airport (Arrival)" },
    { value: "DEPARTURE", label: "Airport (Departure)" },
    { value: "STATION", label: "Train" },
    { value: "PORT", label: "Port" },
    { value: "HOURLY", label: "Hourly" },
    { value: "JOURNEY", label: "Journey" }
];

/**
 * Sorting options for quotes listing.
 * @type {Array<{value: string, text: string}>}
 */
export const SORT_OPTIONS = [
    {
        value: "quoteNumber",
        text: "Quote N°"
    },
    {
        value: "from",
        text: "From"
    },
    {
        value: "to",
        text: "To"
    },
    {
        value: "pickupDate",
        text: "Date & Time"
    },
    {
        value: "passenger",
        text: "Passenger"
    },
    {
        value: "passengersCount",
        text: "N° Passengers"
    },
    {
        value: "status",
        text: "Status"
    },
    {
        value: "typeTransfer",
        text: "Type Transfer"
    },
    {
        value: "createdAt",
        text: "Created At"
    }
]